var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    staticStyle: {
      "margin-bottom": "4px",
      width: "100%"
    },
    attrs: {
      layout: "inline"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("视频来源")
    }
  }, [_c("div", {
    staticClass: "btns",
    class: _vm.current == 1 ? "left" : "",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.current == 1 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("总后台")))]), _c("div", {
    staticClass: "btn",
    class: _vm.current == 2 ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.tabFun(2);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("客户系统")) + " ")])])])], 1), _c("a-form", {
    ref: "form",
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.current === 2,
      expression: "current === 2"
    }],
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("归属客户")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属客户"),
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption2,
      "show-search": ""
    },
    on: {
      change: _vm.customerChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("帐号ID")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("帐号ID"),
      allowClear: ""
    },
    model: {
      value: _vm.form.userId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userId", $$v);
      },
      expression: "form.userId"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("录屏开始时间")
    }
  }, [_c("a-range-picker", {
    attrs: {
      format: _vm.getFormatDate() + " HH:mm:ss" + _vm.dateChronaxie(),
      "show-time": {
        hideDisabledOptions: true,
        defaultValue: _vm.defaultValue
      },
      disabledTime: _vm.disabledTime,
      disabledDate: _vm.disabledDate
    },
    on: {
      change: _vm.onChangeTime,
      openChange: _vm.openChangeDate
    },
    model: {
      value: _vm.form.startRecordTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "startRecordTime", $$v);
      },
      expression: "form.startRecordTime"
    }
  })], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.playVideo(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("播放")))]), _c("a-button", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: record.url,
            expression: "record.url"
          }],
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.downVideo(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("下载")))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.palyVisiable ? _c("playerModal", {
    attrs: {
      record: _vm.record
    },
    on: {
      closeModeal: _vm.closeModeal
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };